var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ImageCropper } from 'root/src/client/v2/image/services/ImageCropper.service';
import { createImage } from 'root/src/client/v2/image/helpers/createImage';
import { canvasToFile } from 'root/src/client/v2/image/helpers/canvasToFile';
export const cropImageToFile = ({ coordinates, source }) => __awaiter(void 0, void 0, void 0, function* () {
    const image = yield createImage(source);
    const canvas = ImageCropper.crop(image, coordinates);
    return canvasToFile(canvas);
});
